import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { IconType, IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-check-formatter-renderer',
  template: `
    <ng-container [ngSwitch]="params?.colDef?.field">
      <ng-container *ngSwitchCase="'validated'">
        <div
          class="h-100 d-flex flex-row align-items-center justify-content-start"
        >
          <pt-icon
            class="checked"
            *ngIf="params?.value"
            [size]="20"
            [key]="validationSuccessIcon"
            [iconType]="IconType.SVG"
          ></pt-icon>
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <div
          class="h-100 d-flex flex-row align-items-center justify-content-start"
        >
          <pt-icon
            class="checked"
            *ngIf="params?.value"
            [size]="20"
            [key]="checkboxOutlineIcon"
            [iconType]="IconType.SVG"
          ></pt-icon>
        </div>
      </ng-container>
    </ng-container>
  `,
})
export class BooleanCellRendererComponent
  implements ICellRendererAngularComp, IHeaderAngularComp
{
  params: any;

  validationSuccessIcon = 'validated.svg';
  minusIcon = IoniconsOutline.minus;

  checkboxOutlineIcon = 'checkbox-outline.svg';
  boxOutlineIcon = 'box-outline.svg';

  IconType = IconType;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
